import * as firebase from "firebase/app";
import {
  browserLocalPersistence,
  connectAuthEmulator,
  indexedDBLocalPersistence,
  initializeAuth,
} from "firebase/auth";
import * as storage from "firebase/storage";
import * as firestore from "firebase/firestore";
import * as functions from "firebase/functions";
import * as database from "firebase/database";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
};

const environment = process.env.NODE_ENV;
const useSandbox = true;

const app = firebase.initializeApp(firebaseConfig);
export const authClient = initializeAuth(app, {
  persistence: [browserLocalPersistence, indexedDBLocalPersistence],
});
const functionsInstance = functions.getFunctions(firebase.getApp());

export const realtimeDB = database.getDatabase();
if (environment === "development" && !useSandbox) {
  const db = firestore.initializeFirestore(firebase.getApp(), {
    experimentalForceLongPolling: !!process.env.REACT_APP_RUN_FOR_CYPRESS,
  });
  firestore.connectFirestoreEmulator(db, "localhost", 8081);
  functions.connectFunctionsEmulator(functionsInstance, "localhost", 5001);
  connectAuthEmulator(authClient, "http://localhost:9099");
  storage.connectStorageEmulator(storage.getStorage(), "localhost", 9199);
  database.connectDatabaseEmulator(realtimeDB, "localhost", 9000);
}

export const db = firestore.initializeFirestore(firebase.getApp(), {
  experimentalForceLongPolling: !!process.env.REACT_APP_RUN_FOR_CYPRESS,
});
export const store = storage.getStorage();
export const storageRef = storage.ref(store);

export const dateToTimestamp = (date: Date) =>
  firestore.Timestamp.fromDate(date);

export type DocumentReference<T> = firestore.DocumentReference<T>;
export type FirestoreError = firestore.FirestoreError;
export type CollectionReference<T> = firestore.CollectionReference<T>;
export type Query<T> = firestore.Query<T>;
export type DocumentSnapshot<T> = firestore.DocumentSnapshot<T>;
export type QuerySnapshot<T> = firestore.QuerySnapshot<T>;
export type QueryDocumentSnapshot<T> = firestore.QueryDocumentSnapshot<T>;
export type DocumentData = firestore.DocumentData;
export type Timestamp = firestore.Timestamp;
export type FirebaseError = firebase.FirebaseError;

export default app;
